import React, { useEffect, useState } from 'react';
import { Box, Grid, GridItem, Skeleton, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../elements/Navbar/Navbar';
import DocumentSelection from '../../components/DocumentSelection';
import NewDocumentForm from '../../components/NewDocumentForm';
import { getRequest, createDocument, getDocumentsSpot } from '../../ServiceRequest';
import Footer from '../../elements/Footer';

const Home: React.FC = () => {
    const navigate = useNavigate();

    const [documents, setDocuments] = useState<any[]>([]);
    const [templates, setTemplates] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [newDocumentData, setNewDocumentData] = useState<any>({});

    const getDocuments = async () => {
        try {
            const documentFields = [
                "_id",
                "projectId",
                "name",
                "template.description",
                "templateName",
                "creationDate",
                "lastModificationDate",
            ];
            const [documentsList, templatesList] = await Promise.all([
                //getRequest('/documents'),
                getDocumentsSpot(documentFields),
                getRequest('/templates'),
            ]);
            setDocuments(Array.isArray(documentsList?.data) ? documentsList.data : []);
            setTemplates(templatesList);
        } catch (err) {
            console.error(err);
            setError('Error while fetching data');
        } finally {
            setLoading(false);
        }
    };

    const handleNewDocumentData = (e: any) => {
        const { name, value } = e.target;
        setNewDocumentData({
            ...newDocumentData,
            [name]: value,
        });
    };

    const handleCreateNewDocument = async (e: any) => {
        if (newDocumentData) {
            const newDocument = await createDocument(
                newDocumentData.name,
                newDocumentData.description,
                newDocumentData.templateName,
                newDocumentData.projectId
            );

            navigate(
                `/${newDocument.data.projectId}/${newDocument.data._id}/${newDocument.data.templateName}`
            );
        }
    };

    const openDocument = (template_name: string, document_id: string, project_id: string) => {
        navigate(`/${project_id}/${document_id}/${template_name}`);
    };

    useEffect(() => {
        getDocuments();
    }, []);

    return (
        <>
            <Navbar />
            <Box className="container">
                <Grid templateColumns="repeat(12, 1fr)" gap={12}>
                    <GridItem colSpan={8}>
                        {loading ? (
                            <VStack spacing={4} align="stretch">
                                <Skeleton height="40px" />
                                <Skeleton height="40px" />
                                <Skeleton height="40px" />
                            </VStack>
                        ) : (
                            <DocumentSelection documents={documents} openDocument={openDocument} />
                        )}
                    </GridItem>


                    <GridItem colSpan={4}>
                        {loading ? (
                            <VStack spacing={4} align="stretch">
                                <Skeleton height="40px" />
                                <Skeleton height="40px" />
                                <Skeleton height="40px" />
                                <Skeleton height="40px" />
                            </VStack>
                        ) : (
                            <NewDocumentForm
                                templates={templates}
                                handleNewDocumentData={handleNewDocumentData}
                                handleCreateNewDocument={handleCreateNewDocument}
                            />
                        )}
                    </GridItem>
                </Grid>
            </Box>
            <Footer />
        </>

    );
};

export default Home;